import { Button as ButtonComponent } from './Button';
import { CheckableButton as Checkable } from './CheckableButton';
import { Group } from './Group';
export var Button = Object.assign(ButtonComponent, {
  Group: Group,
  Checkable: Checkable
});